import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

/**
 * This cross icon is now deprecated, please use the CrossIcon
 */
export const CrossIconOld = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '10';
			case SIZE.STANDARD:
				return '12';
			default:
				return '12';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width={getWidth(size)} height={getHeight(size)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
				<g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" strokeLinecap="square">
					<path d="M2.308 9.692l7.384-7.384M2.308 2.308l7.384 7.384" />
				</g>
			</svg>
		</StyledSpan>
	);
};
CrossIconOld.SIZE = SIZE;
CrossIconOld.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

CrossIconOld.defaultProps = {
	color: '#565656',
};
const StyledSpan = Styled.span`
	cursor: pointer;
	display: flex;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
	align-self: center;
`;
